import { IConfig } from "shared/types/configuration";
import HttpClient from "./httpClient";
import { User } from "redux/auth/auth.slice";

export default ({ config }: { headers: any; config: IConfig }) => ({
  upserUserAttrs: (user: User & { sub?: string }) =>
    HttpClient.post(config.services.base.upserUserAttrs, user),
});
